// AV - 3/7/18 - WEB-10774
// these constants are explicitly not related to STATION_TYPE variables since these are exclusively set this way for interop with amp
export const STREAM_TYPE = {
  ARTIST: 'ARTIST',
  COLLECTION: 'COLLECTION',
  RADIO: 'RADIO',
  FAVORITE: 'FAVORITE',
};
